"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _react = _interopRequireWildcard(require("react")),
    _fileTypes = require("../../../common/constants/fileTypes"),
    _utils = require("../../../common/utils"),
    _ImagePreview = _interopRequireDefault(require("./ImagePreview")),
    _VideoPreview = _interopRequireDefault(require("./VideoPreview")),
    _AudioPreview = _interopRequireDefault(require("./AudioPreview")),
    _FontPreview = _interopRequireDefault(require("./FontPreview")),
    _OtherPreview = _interopRequireDefault(require("./OtherPreview"));

require("../styles/_asset-preview.scss");

function hasValidAssetFile(_ref) {
  var assetFiles = _ref.assetFiles,
      type = _ref.type;
  if (!assetFiles) return !1;
  var ORIGINAL = assetFiles.ORIGINAL,
      SD = assetFiles.SD,
      STREAM = assetFiles.STREAM;
  return ORIGINAL && ORIGINAL.sourceUrl || type === _fileTypes.VIDEO && SD && SD.sourceUrl || type === _fileTypes.VIDEO && STREAM && STREAM.sourceUrl && STREAM.fragments.length;
}

function getPreviewComponentFromAsset(asset, _ref2) {
  var canPlayVideo = _ref2.canPlayVideo,
      canPlayAudio = _ref2.canPlayAudio;
  if (!asset) return {
    component: _OtherPreview["default"],
    type: _fileTypes.OTHER
  };
  if ((0, _utils.isAssetMissing)(asset)) return {
    component: _OtherPreview["default"],
    type: _fileTypes.OTHER,
    assetMissing: !0
  };
  var loadedPercent = asset.loadedPercent,
      metaData = asset.metaData,
      filename = asset.filename,
      assetFiles = asset.assetFiles,
      type = (0, _utils.getTypeFromAsset)({
    metaData: metaData,
    filename: filename
  }),
      hasLoadableFile = hasValidAssetFile({
    assetFiles: assetFiles,
    type: type
  });
  return (void 0 === loadedPercent || 100 === loadedPercent) && hasLoadableFile ? type === _fileTypes.IMAGE ? {
    component: _ImagePreview["default"],
    type: type
  } : type === _fileTypes.VIDEO ? {
    component: _VideoPreview["default"],
    type: type,
    canPlayVideo: canPlayVideo
  } : type === _fileTypes.FONT ? {
    component: _FontPreview["default"],
    type: type
  } : type !== _fileTypes.AUDIO || canPlayAudio ? type === _fileTypes.AUDIO ? {
    component: _AudioPreview["default"],
    type: type
  } : {
    component: _OtherPreview["default"],
    type: type
  } : {
    component: _OtherPreview["default"],
    type: type
  } : {
    component: _OtherPreview["default"],
    type: type
  };
}

function getStyleMeasurement(value) {
  return "string" == typeof value ? value : "".concat(value, "px");
}

var AssetPreviewBase = function AssetPreviewBase(props) {
  var asset = props.asset,
      canPlayVideo = props.canPlayVideo,
      canPlayAudio = props.canPlayAudio,
      hideFileTypeIcon = props.hideFileTypeIcon,
      darkMode = props.darkMode,
      _getPreviewComponentF = getPreviewComponentFromAsset(asset, {
    canPlayVideo: canPlayVideo,
    canPlayAudio: canPlayAudio
  }),
      Preview = _getPreviewComponentF.component,
      type = _getPreviewComponentF.type,
      additionalProps = (0, _objectWithoutProperties2["default"])(_getPreviewComponentF, ["component", "type"]);

  return _react["default"].createElement(Preview, (0, _extends2["default"])({
    asset: asset,
    type: type,
    hideFileTypeIcon: hideFileTypeIcon,
    darkMode: darkMode
  }, additionalProps));
};

function AssetPreview(_ref3) {
  var asset = _ref3.asset,
      canPlayVideo = _ref3.canPlayVideo,
      canPlayAudio = _ref3.canPlayAudio,
      _ref3$width = _ref3.width,
      width = void 0 === _ref3$width ? "100%" : _ref3$width,
      _ref3$height = _ref3.height,
      height = void 0 === _ref3$height ? 130 : _ref3$height,
      _ref3$borderRadius = _ref3.borderRadius,
      borderRadius = void 0 === _ref3$borderRadius ? 2 : _ref3$borderRadius,
      hideFileTypeIcon = _ref3.hideFileTypeIcon,
      darkMode = _ref3.darkMode;
  return void 0 === asset ? null : _react["default"].createElement("div", {
    className: "asset-preview",
    style: {
      height: getStyleMeasurement(height),
      width: getStyleMeasurement(width),
      borderRadius: getStyleMeasurement(borderRadius)
    }
  }, _react["default"].createElement(AssetPreviewBase, {
    asset: asset,
    canPlayVideo: canPlayVideo,
    canPlayAudio: canPlayAudio,
    hideFileTypeIcon: hideFileTypeIcon,
    darkMode: darkMode
  }));
}

var _default = (0, _react.memo)(AssetPreview);

exports["default"] = _default;